module.exports = __webpack_public_path__ + "12a5c6a9deb8985add4ad68ee6720d01.svg";